// extracted by mini-css-extract-plugin
module.exports = {"checkWrapper":"styles_checkWrapper__yVYh4","checkContainer":"styles_checkContainer__ZdYvw"};